import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export type TrendEntry = {
  reportDate: string;
  trendValue: number | null;
};

export const chartOptions = (entries: TrendEntry[]): Highcharts.Options => ({
  exporting: {
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },
  lang: {
    noData: 'No Data Available',
  },
  noData: {
    style: {
      fontSize: '16px',
    },
    attr: {
      class: 'no-data',
    },
  },
  chart: {
    backgroundColor: undefined,
    borderWidth: 0,
    type: 'line',
    margin: 5,
    style: {
      overflow: 'visible',
    },
    events: {},
  },
  title: {
    text: undefined,
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
    startOnTick: false,
    endOnTick: false,
    tickPositions: [],
    lineWidth: 1,
    lineColor: '#fff',
  },
  yAxis: {
    endOnTick: false,
    startOnTick: false,
    labels: {
      enabled: false,
    },
    title: {
      text: undefined,
    },
    tickPositions: [0],
    min: 0,
    lineWidth: 0,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      marker: {},
      allowPointSelect: false,
      lineWidth: 1,
      shadow: false,
      states: {
        hover: {
          enabled: false,
        },
      },
      connectNulls: false,
      animation: {
        duration: 500,
      },
    },
  },
  series: [
    {
      type: 'line',
      color: unifiedPlatformColorPalette.chartLightBlue,
      lineWidth: 2,
      data: entries
        .map((stat, index) => ({
          x: Date.parse(stat.reportDate),
          y: stat.trendValue,
          marker: {
            enabled: index === entries.length - 1,
            radius: 5,
          },
        }))
        .sort((a, b) => a.x - b.x),
      showInLegend: false,
    },
  ],
});
